export default __webpack_public_path__ + "static/media/trust.a12c708e.png";